import {Route, Routes} from 'react-router-dom';
import './App.css';
import Home from "./components/Home/Home"
import Shop from "./components/Shop/App"
import Upgrade from "./components/Upgrade/Upgrade"
import Configure from "./components/Configure/Configure"
import News from "./components/News/News"
import AboutUs from "./components/AboutUs/AboutUs"
import {useEffect, useState} from 'react';
import BeatLoader from "react-spinners/BeatLoader";
import NotFound from './components/NotFound/NotFound';
import MainProfile from './components/MainProfile/MainProfile';
import Cart from './components/Cart/Cart';
import UserList from './pages/pages/userList/UserList';
import NewUser from './pages/pages/newUser/NewUser';
import User from './pages/pages/user/User';
import ProductList from './pages/pages/productList/ProductList';
import Product from './pages/pages/product/Product';
import NewProduct from './pages/pages/newProduct/NewProduct';
import Configurator from './components/Configure/Configurator/Configurator';


// import MainProfile from "./components/MainProfile/MainProfile"


function App() {
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 3000);
    }, [])
    return (
        <div className="App">

            {
                loading ?
                    <BeatLoader className="loader" color={"#00ADB5"} loading={loading} size={18}/>
                    :
                    <>

                        <Routes>
                            <Route path="/" element={<Home/>}/>
                            <Route path="/Home" element={<Home/>}/>
                            <Route path="/Shop" element={<Shop/>}/>
                            <Route path="/Upgrade" element={<Upgrade/>}/>
                            <Route path="/Configure" element={<Configure/>}/>
                            <Route path="/News" element={<News/>}/>
                            <Route path="/Aboutus" element={<AboutUs/>}/>
                            <Route path="/MainProfile" element={<MainProfile/>}/>
                            <Route path="/Cart" element={<Cart/>}/>
                            <Route path="/*" element={<NotFound/>}/>
                            <Route path="/Users" element={<UserList/>}/>
                            <Route path="/User/:userId" element={<User/>}/>
                            <Route path="/NewUser" element={<NewUser/>}/>
                            <Route path="/Products" element={<ProductList/>}/>
                            <Route path="/Product/:ProductId" element={<Product/>}/>
                            <Route path="/NewProduct" element={<NewProduct/>}/>
                            <Route path="/Configurator" element={<Configurator/>}/>

                            {/* <Route path="/AdminDashboard" exact element={<AdminHome/>}/> */}
                        </Routes>
                    </>
            }
        </div>
    );
}

export default App;
